var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgView(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 17.079,
    height: 15,
    viewBox: "0 0 17.079 15",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_6648",
    "data-name": "Group 6648",
    transform: "translate(6245.985 9303)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6647",
    "data-name": "Group 6647",
    transform: "translate(-24 51)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6635",
    "data-name": "Group 6635",
    transform: "translate(192 33)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_617",
    "data-name": "Rectangle 617",
    width: 15,
    height: 15,
    transform: "translate(-6413 -9387)",
    fill: "none"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_6646",
    "data-name": "Group 6646",
    transform: "translate(-111.05 19.743)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1032",
    "data-name": "Path 1032",
    d: "M-6128.017-9374.521s3.622-5.6,8.147-5.527,7.932,5.527,7.932,5.527-3.406,5.062-7.932,4.984S-6128.017-9374.521-6128.017-9374.521Z",
    transform: "translate(-6.418 59.55)",
    fill: "none",
    stroke: "#14a4c2",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_161",
    "data-name": "Ellipse 161",
    transform: "translate(-6129.498 -9318.437)",
    fill: "none",
    stroke: "#ffa539",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 3.195,
    cy: 3.193,
    rx: 3.195,
    ry: 3.193,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 3.195,
    cy: 3.193,
    rx: 2.695,
    ry: 2.693,
    fill: "none"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgView);
export default __webpack_public_path__ + "static/media/View.b23590384609e56477223b713392b727.svg";
export { ForwardRef as ReactComponent };